import styled from 'styled-components';

const MapTextStyle = styled.div`
  color: white;
  background-color: var(--gray-1);
  padding: 15px 10px;
  display: inline-flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  transform: translate(-50%, -50%);
`;

export default MapTextStyle;
